import { render, staticRenderFns } from "./VoteButtonNew.vue?vue&type=template&id=cfb611ac&scoped=true&"
import script from "./VoteButtonNew.vue?vue&type=script&lang=ts&"
export * from "./VoteButtonNew.vue?vue&type=script&lang=ts&"
import style0 from "./VoteButtonNew.vue?vue&type=style&index=0&id=cfb611ac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb611ac",
  null
  
)

export default component.exports